export default __webpack_public_path__ + "2685c3447d9ae49f6ebe702f84552694.webp";